import { AbsenceChange, ActionTypeEnum, LogsItem, ShiftChange, TaskChange } from '../../../types/interfaces';

export const getTaskInfo = (rowData: LogsItem): { taskId?: number; taskName?: string } => {
  if (rowData.added) {
    const addedArray = Array.isArray(rowData.added) ? rowData.added : [rowData.added];
    const taskItem = addedArray.find((item): item is TaskChange => 
      (item as TaskChange)?.taskId !== undefined
    ) as TaskChange | undefined;
    if (taskItem?.taskId) {
      return { taskId: taskItem.taskId, taskName: taskItem.taskName };
    }
  }
  if (rowData.deleted) {
    const deletedArray = Array.isArray(rowData.deleted) ? rowData.deleted : [rowData.deleted];
    const taskItem = deletedArray.find((item): item is TaskChange => 
      (item as TaskChange)?.taskId !== undefined
    ) as TaskChange | undefined;
    if (taskItem?.taskId) {
      return { taskId: taskItem.taskId, taskName: taskItem.taskName };
    }
  }
  return {};
};

export const isShiftAction = (actionType: ActionTypeEnum): boolean => {
  return actionType <= ActionTypeEnum.GENERATION;
};

export const isAbsenceAction = (actionType: ActionTypeEnum): boolean => {
  return (
    actionType === ActionTypeEnum.CREATEABSENCE ||
    actionType === ActionTypeEnum.UPDATEABSENCE ||
    actionType === ActionTypeEnum.DELETEABSENCE
  );
};

export const isTaskAction = (actionType: ActionTypeEnum): boolean => {
  return (
    actionType === ActionTypeEnum.CREATETASK ||
    actionType === ActionTypeEnum.DEPARTMENTCHANGEDINTASK ||
    actionType === ActionTypeEnum.PERSONCHANGEDINTASK ||
    actionType === ActionTypeEnum.DELETETASK
  );
};

export const getAddedItems = (rowData: LogsItem): (ShiftChange | AbsenceChange | TaskChange)[] => {
  if (!rowData.added) return [];
  return Array.isArray(rowData.added) ? rowData.added : [rowData.added];
};

export const getDeletedItems = (rowData: LogsItem): (ShiftChange | AbsenceChange | TaskChange)[] => {
  if (!rowData.deleted) return [];
  return Array.isArray(rowData.deleted) ? rowData.deleted : [rowData.deleted];
};

export const getUpdatedItems = (
  addedItems: (ShiftChange | AbsenceChange | TaskChange)[],
  deletedItems: (ShiftChange | AbsenceChange | TaskChange)[],
  actionType: ActionTypeEnum
): Array<{
  id: number;
  old: ShiftChange | AbsenceChange;
  new: ShiftChange | AbsenceChange;
}> => {
  const isUpdateAction =
    actionType === ActionTypeEnum.UPDATE ||
    actionType === ActionTypeEnum.UPDATEABSENCE;

  if (!isUpdateAction || addedItems.length === 0) {
    return [];
  }

  const isShift = actionType === ActionTypeEnum.UPDATE;

  return addedItems.map((added, index) => ({
    id: added.id || 0,
    old:
      index < deletedItems.length
        ? (deletedItems[index] as ShiftChange | AbsenceChange)
        : isShift
          ? ({} as ShiftChange)
          : ({} as AbsenceChange),
    new: added as ShiftChange | AbsenceChange
  }));
};

export const getActionLabel = (actionType: ActionTypeEnum): string => {
  switch (actionType) {
  case ActionTypeEnum.CREATE:
  case ActionTypeEnum.CREATEABSENCE:
  case ActionTypeEnum.CREATETASK:
    return 'Добавленные';
  case ActionTypeEnum.UPDATE:
  case ActionTypeEnum.UPDATEABSENCE:
    return 'Обновленные';
  case ActionTypeEnum.DELETE:
  case ActionTypeEnum.DELETEABSENCE:
  case ActionTypeEnum.DELETETASK:
    return 'Удаленные';
  case ActionTypeEnum.GENERATION:
    return 'Сгенерированные';
  case ActionTypeEnum.DEPARTMENTCHANGEDINTASK:
  case ActionTypeEnum.PERSONCHANGEDINTASK:
    return 'Измененные';
  default:
    return 'Неизвестные';
  }
};
